import { hideElement, update_tooltip, update_tooltip_right, animateElement } from "./update_tooltip.js"
import { showCustomAlert } from "./modal_dialog.js"
import { imgPath } from "./math_functions.js"

var tooltip_effect_type_transformation = {
    "aspect": "Aspect",
    "fragment": "Fragment",
    "grenade_ability": "Grenade",
    "class_ability": "Class Ability",
    "melee_ability": "Melee",
    "super_ability": "Super Ability",
    "armor_mod": "Armor Mod",
    "exotic_armor": "Exotic Armor",
    "exotic_weapon": "Exotic Weapon"
};

var menu_type_to_columns_rows = {
    'abilities_menu': [4, 2],
    'aspects_menu': [4, 2],
    'fragments_menu': [7, 2],
    'exotics_menu': [6, 2,],
    'armor_mods_menu': [4, 2],
};

export class Menu_manager
{
    constructor(character, commander)
    {
        this.character = character;
        this.character.menu = this;

        this.commander = commander;

        // technical part
        this.currentSlot = null;

        this.pointer_inside_button = false;

        this.screen_width = 0;
        this.has_touch_screen = false;

        this.tooltip = new Tooltip();
        this.menu = new SelectionMenu(this, this.tooltip);

        console.log('this.menu', this.menu)

        if ('ontouchstart' in window)
        {
            console.log('APP/MENU: has_touchscreen==true');
            this.has_touch_screen = true;
        }
        else
        {
            console.log('APP/MENU: has_touchscreen==false');
        }

        // slots
            //constructor(menuComponents, socketSpecs, ButtonSpecs, selection)

        this.menuComponents = {
            manager: this,
            menu: this.menu,
            tooltip: this.tooltip,
        };

        this.slots = {};
    }

    addSlot(category, socketSpecs, buttonSpecs, selection)
    {
        if (!(category in this.slots))
        {
            this.slots[category] = [];
        }

        this.slots[category].push(new Slot(this.menuComponents, socketSpecs, buttonSpecs, selection));
    }

    updateSlotSelection(category, index, selection)
    {
        if (category in this.slots)
        {
            if (this.slots[category].length > index)
            {
                this.slots[category][index].updateSelection(selection);
            }
        }
    }

    dehighlightCurrentSlot()
    {
        console.log("APP/MNU: LEVEL_1_BUTTON_FLUSH()");
        if (this.currentSlot != null)
        {
            this.currentSlot.dehighlight()
            this.currentSlot = null;
        }
    }

    tooltip_show(html_element_id, effect_id, button_level)
    {
        console.log('APP/MNU: TOOLTIP_SHOW()');

        update_tooltip(this.character, effect_id, this.getDisplayMode(), button_level);

        let tooltip_right_status = update_tooltip_right(this.character, effect_id);
        let tooltip = document.getElementById("tooltip");
        let trait_side = "to_right";

        if (this.screen_width > 1000 && !this.has_touch_screen)
        {
            let tooltip_bounding_rect = tooltip.getBoundingClientRect();
            let button_bounding_rect = document.getElementById(html_element_id).getBoundingClientRect();
            let margin_left = button_bounding_rect.right + 5;
            let margin_right = window.innerWidth - margin_left - 400;

            if (margin_right < 0)
            {
                margin_left += margin_right - 5;
                margin_right = 5;
            }

            if (margin_left >= margin_right)
            {
                if (margin_left < 410 && tooltip_right_status)
                    tooltip.style.left = "420px";
                else
                    tooltip.style.left = `${margin_left}px`

                trait_side = "to_left";
            }
            else
            {
                if (margin_right < 410 && tooltip_right_status)
                    tooltip.style.left = `${window.innerWidth - 820}px`;
                else
                    tooltip.style.left = `${margin_left}px`

                trait_side = "to_right"
            }

            let height;
            if (tooltip_right_status)
            {
                console.log("max:", document.getElementById("tooltip_right").getBoundingClientRect().height, tooltip_bounding_rect.height)
                height = Math.max(document.getElementById("tooltip_right").getBoundingClientRect().height, tooltip_bounding_rect.height);
            }
            else
                height = tooltip_bounding_rect.height;

            let vertical_margin = Math.floor((window.innerHeight -  height) / 2);
            let button_middle = button_bounding_rect.top + Math.round(button_bounding_rect.height / 2);

            if (vertical_margin > button_middle)
            {
                tooltip.style.top = `${button_middle + window.scrollY}px`;
            }
            else if (vertical_margin > window.innerHeight - button_middle)
            {
                tooltip.style.top = `${button_middle - height + window.scrollY}px`;
            }
            else
            {
                tooltip.style.top = `${vertical_margin + window.scrollY}px`;
            }

            tooltip.style.visibility = "visible";
            tooltip.style.opacity = 1;

            if (tooltip_right_status)
            {
                let tooltip_right = document.getElementById("tooltip_right");
                tooltip_right.style.left = tooltip.style.left;
                tooltip_right.style.top = tooltip.style.top;
                animateElement(tooltip_right, trait_side);
            }
        }
        else
        {
            let selection_menu = document.getElementById('selection_menu');
            let position = selection_menu.getBoundingClientRect();
            tooltip.style.visibility = "visible";
            tooltip.style.opacity = 1;

            selection_menu.style.bottom = tooltip.getBoundingClientRect().height + 'px';
        }
    }

    onMenuHide()
    {
        this.dehighlightCurrentSlot();
    }

    class_button_click(class_name)
    {
        console.log("APP/MNU: CLASS_BUTTON_CLICK()", class_name);
        this.tooltip.hide();
        this.menu.hide();

        this.commander.exec_command(
            {
                command_type: "set_effect",
                effect_id: class_name,
                effect_type: 'class',
                slot_index: null,
                armor_slot: null,
            }
        );
    }

    subclass_button_click(subclass_id)
    {
        console.log("APP/MNU: SET_SUBCLASS()", subclass_id);
        this.tooltip.hide();
        this.menu.hide();

        this.commander.exec_command(
            {
                command_type: "set_effect",
                effect_id: subclass_id,
                effect_type: 'subclass',
                slot_index: null,
                armor_slot: null,
            }
        );
    }

    adapt_to_screensize()
    {
        this.tooltip.hide();
        this.menu.hide();

        let selection_menu = document.getElementById("selection_menu");
        let tooltip = document.getElementById("tooltip");
        let tooltip_right = document.getElementById("tooltip_right");

        if (this.has_touch_screen)
        {
            document.getElementById("selection_menu_insert").style.display = "block";
            document.getElementById("selection_menu_close").style.display = "block";
            if (this.screen_width < 1000)
            {
                selection_menu.className = 'selection_menu selection_menu_touch_small';
                tooltip.className = 'tooltip tooltip_touch_small';
            }
            else if (this.screen_width < 1500)
            {
                selection_menu.className = 'selection_menu selection_menu_touch_medium';
                tooltip.className = 'tooltip tooltip_touch_medium';
            }
            else
            {
                selection_menu.className = 'selection_menu selection_menu_touch_large';
                tooltip.className = 'tooltip tooltip_touch_large';
            }
        }
        else
        {
            if (this.screen_width < 1000)
            {
                document.getElementById("selection_menu_insert").style.display = "block";
                document.getElementById("selection_menu_close").style.display = "block";
                selection_menu.className = 'selection_menu selection_menu_nontouch_small';
                tooltip.className = 'tooltip tooltip_nontouch_small';
            }
            else if (this.screen_width < 1500)
            {
                document.getElementById("selection_menu_insert").style.display = "none";
                document.getElementById("selection_menu_close").style.display = "none";
                selection_menu.className = 'selection_menu selection_menu_nontouch_medium';
                tooltip.className = 'tooltip tooltip_nontouch_medium_large';
            }
            else
            {
                document.getElementById("selection_menu_insert").style.display = "none";
                document.getElementById("selection_menu_close").style.display = "none";
                selection_menu.className = 'selection_menu selection_menu_nontouch_large';
                tooltip.className = 'tooltip tooltip_nontouch_medium_large';
            }
        }
    }

    screen_size_change()
    {
        console.log('SCREEN_SIZE_CHANGE');
        this.screen_width = window.innerWidth;
        //console.log(this.screen_width, 'has_touch_screen:', this.has_touch_screen);
        this.adapt_to_screensize();
    }

    getDisplayMode()
    {
        if (this.has_touch_screen || (!this.has_touch_screen && this.screen_width < 1000))
        {
            return "mobile";
        }
        else // (this.screen_width >= 1000 && !this.has_touch_screen)
        {
            return "pc";
        }
    }

}

class SelectionMenu
{
    constructor(manager, tooltip)
    {
        this.manager = manager;

        this.masterSlot = null;
        this.anchor = null;
        this.masterButton = null;
        this.side = ''; // left, right, down

        this.selectedButtonHtmlId = '';
        this.selectedButtonEffectId = '';
        this.selectedButtonEffectType = '';

        this.tooltip = tooltip;

        this.innerButtons = [];

        for (let i = 0; i < 28; i++)
        {
            let button = document.getElementById(`selection_menu_item_button_${i}`);

            button.addEventListener(
                'pointerenter',
                (event) => {
                    let element = event.currentTarget;
                    //console.log("APP/MNU: LEVEL_2_POINTER_ENTER()")
                    this.enteredButton(element.id, element.getAttribute('data-effect-id'), element.getAttribute('data-effect-type'));
                }
            );
            button.addEventListener(
                'click',
                (event) => {
                    this.clickedButton(event);
                }
            );
            button.addEventListener('pointerleave', (event) => { this.buttonLeft() });

            this.innerButtons.push(button);
        }
        document.getElementById("selection_menu").addEventListener('pointerleave', (event) => {  this.onLeave() } );
        document.getElementById("selection_menu_close").addEventListener('click', (event) => {  this.clickedCloseButton() } );
        document.getElementById("selection_menu_insert").addEventListener('click', (event) => {  this.clickedInsertButton() } );
    }

    show(slot, idList, whatInSlot, character) // TODO: do something with character
    {
        console.log('APP/MNU: SELECTION_MENU_SHOW()', whatInSlot);
        //event.stopPropagation();
        let self = document.getElementById("selection_menu");

        let htmlElement = slot.button;
        let buttonGroup = slot.buttonGroup;
        let menu_type = htmlElement.getAttribute('data-menu-type');
        let [columns, rows] = menu_type_to_columns_rows[menu_type];

        this.clearButtonSelection();
        this.setMaster(slot, buttonGroup, htmlElement);

        this.updateButtons(idList, columns, rows, whatInSlot, character);

        let selection_container = document.getElementById('selection_container');

        if (this.manager.getDisplayMode() == "pc") //(this.screen_width >= 1000 && !this.has_touch_screen)
        {
            let position = buttonGroup.getBoundingClientRect();
            self.style.top = `${position.bottom + window.scrollY - 11}px`; //+ 10
            self.style.left = `${position.left}px`;

            selection_container.className = `selection_container_for_${menu_type}`;
        }
        else
        {
            selection_container.className = 'selection_container_auto';
        }

        self.style.visibility = "visible";
        self.style.opacity = 1;
    }

    updateButtons(idList, columns, rows, whatInSlot, character) // TODO: character should not be here
    {
        console.log('APP/MNU: updateButtons()', whatInSlot, idList);
        let characterElement = character.element;
        let elementsLen = idList.length;

        rows = Math.max(rows, Math.ceil(elementsLen / columns));
        let total_elements = rows * columns;

        // filled buttons
        for (let i = 0; i < elementsLen; i++)
        {
            let effect = character.get_effect(idList[i]);
            console.log(effect)
            let effectImg = imgPath(effect.display_properties.icon);

            let button = this.innerButtons[i];
            button.setAttribute('data-effect-type', effect.type);
            button.setAttribute('data-effect-id', idList[i]);
            button.style.display = 'block';

            if (whatInSlot == idList[i])
            {
                button.setAttribute('data-already-inserted', "true");
                button.classList.add('item_button_disabled');
            }
            else
            {
                button.setAttribute('data-already-inserted', "false");
                button.classList.remove('item_button_disabled');
            }

            document.getElementById(`selection_menu_item_button_${i}_img`).src = `${effectImg}`;

            let cornerImg = document.getElementById(`selection_menu_item_button_${i}_corner`);


            if (effect.display_properties.watermark != null)
            {
                cornerImg.style.visibility = 'visible';
                cornerImg.src = imgPath(effect.display_properties.watermark);
            }
            else
            {
                cornerImg.style.visibility = 'hidden';
            }

            document.getElementById(`selection_menu_slot_${i}`).style.display = 'block';
        }

        if (this.manager.getDisplayMode() == "mobile")//(this.has_touch_screen || (!this.has_touch_screen && this.screen_width < 1000))
        {
            // hidden buttons
            for (let i = elementsLen; i < 28; i++)
            {
                document.getElementById(`selection_menu_slot_${i}`).style.display = 'none';
            }
        }
        else
        {
            // empty buttons
            for (let i = elementsLen; i < total_elements; i++)
            {
                document.getElementById(`selection_menu_slot_${i}`).style.display = 'block';

                let button = this.innerButtons[i];
                button.style.display = 'none';
                button.setAttribute('data-effect-type', '');
                button.setAttribute('data-effect-id', '');
            }
            // hidden buttons
            for (let i = total_elements; i < 28; i++)
            {
                document.getElementById(`selection_menu_slot_${i}`).style.display = 'none';
            }
        }
    }

    hide()
    {
        //console.log('APP/MNU: SELECTION_MENU_HIDE()');
        // TODO: this should be a method for masterButton
        this.manager.onMenuHide();

        this.clearButtonSelection();
        this.clearMaster();

        document.getElementById('selection_menu').style.visibility = "hidden";
        document.getElementById('selection_menu').style.opacity = 0;
    }

    selectButton(html_element_id, effect_id, effect_type)
    {
        console.log("APP/MNU: LEVEL_2_BUTTON_SELECTED()")
        this.selectedButtonHtmlId = html_element_id;
        this.selectedButtonEffectId = effect_id;
        this.selectedButtonEffectType = effect_type;
    }

    setMaster(slot, anchor, masterButton)
    {
        this.masterSlot = slot;
        this.anchor = anchor;
        this.masterButton = masterButton;
        //this.side = side; // left, right, down
    }

    clearMaster()
    {
        this.masterSlot = null;
        this.anchor = null;
        this.masterButton = null;
        this.side = ''; // left, right, down
    }

    clearButtonSelection()
    {
        this.selectedButtonHtmlId = '';
        this.selectedButtonEffectId = '';
        this.selectedButtonEffectType = '';
    }

    enteredButton(htmElementId, effectId, effectType)
    {
        if (this.manager.getDisplayMode() == "pc" && this.masterButton != null)//(this.screen_width >= 1000 && !this.has_touch_screen)
        {
            this.selectButton(htmElementId, effectId, effectType);
            /// TODO: this should be a this.tooltip.show()
            this.manager.tooltip_show(htmElementId, effectId, 2);
        }
    }

    clickedButton(event)
    {
        let element = event.currentTarget;

        console.log("APP/MNU: LEVEL_2_BUTTON_CLICK():");

        if (this.masterButton == null)
        {
            console.log('APP/MNU: SELECTION MENU IS FADING, CLICK BLOCKED');
            return;
        }

//        if (element.getAttribute("data-already-inserted") == "true")
//        {
//            showCustomAlert("Already in slot!");
//            this.tooltip.hide();
//            return;
//        }
//
//        let html_element_id = element.id;
//        let effect_id = element.getAttribute('data-effect-id');
//        let effect_type = element.getAttribute('data-effect-type');

        if (this.manager.getDisplayMode() == 'mobile')//(this.has_touch_screen || (!this.has_touch_screen && this.screen_width < 1000))
        {
            if (element.getAttribute("data-already-inserted") == "true")
            {
                showCustomAlert("Already in slot!");
                return;
            }
            else
            {
                let html_element_id = element.id;
                let effect_id = element.getAttribute('data-effect-id');
                let effect_type = element.getAttribute('data-effect-type');
                this.selectButton(html_element_id, effect_id, effect_type);
                /// TODO: this should be a this.tooltip.show()
                this.manager.tooltip_show(html_element_id, effect_id, 2);
            }
        }
        else
        {
            if (element.getAttribute("data-already-inserted") == "true")
            {
                showCustomAlert("Already in slot!");
                this.tooltip.hide();
                return;
            }

            let html_element_id = element.id;
            let effect_id = element.getAttribute('data-effect-id');
            let effect_type = element.getAttribute('data-effect-type');

            this.masterSlot.sendChosenEffect(effect_id, effect_type);

            this.hide();
            this.tooltip.hide();
        }
    }

    clickedInsertButton()
    {

        console.log('APP/MNU: INSERT_BUTTON_CLICK()', this.selectedButtonEffectId, this.selectedButtonEffectType);
        if (this.selectedButtonHtmlId != "")
        {
            this.masterSlot.sendChosenEffect(this.selectedButtonEffectId, this.selectedButtonEffectType);

            this.hide();
            this.tooltip.hide();
        }
    }
    
    clickedCloseButton()
    {
        console.log('APP/MNU: CLOSE_BUTTON_CLICK()');
        this.hide();
        this.tooltip.hide();
    }

    buttonLeft() //is called from html -> menu manager
    {
        if (this.manager.getDisplayMode() == "pc")
        {
            this.tooltip.hide();
            this.clearButtonSelection();
        }
    }

    onLeave()
    {
        if (this.manager.getDisplayMode() == "pc")
        {
            console.log('APP/MNU: SELECTION_MENU_LEAVE()');
            if (!this.manager.pointer_inside_button)
            {
                this.hide();
            }
            else
            {
                console.log('already in button!');
            }
        }
    }
}

class Tooltip
{
    constructor()
    {
        
    }
    
    hide()
    {
        console.log('APP/MNU: TOOLTIP_HIDE()');

        document.getElementById('tooltip').style.visibility = "hidden";
        document.getElementById('tooltip').style.opacity = 0;

        hideElement(document.getElementById('tooltip_right'));
    }
}


//SocketView
//{
//    constructor(socket, button, selection)
//

class Slot  //
{
    constructor(menuComponents, socketSpecs, buttonSpecs, selection)
    {
        // links
        this.manager = menuComponents.manager;
        this.menu = menuComponents.menu;
        this.tooltip = menuComponents.tooltip;

        // masterItem specifications
        console.log("masterItem: ", socketSpecs.masterItem )
        this.masterItem = socketSpecs.masterItem;
        this.socketCategory = socketSpecs.socketCategory;
        this.socketIndex = socketSpecs.socketIndex;

        let socketKey = this.masterItem.sockets.categories[this.socketCategory][this.socketIndex];
        //console.log(this.masterItem, this.socketCategory, this.socketIndex)

        this.socket = this.masterItem.sockets.entries[socketKey];
        this.socket.subscribe(this);

        // HTML data
        console.log("group", buttonSpecs.buttonGroup)
        this.button = document.getElementById(buttonSpecs.buttonId);
        this.buttonImage = document.getElementById(`${this.button.id}_img`);

        this.buttonWatermark = document.getElementById(`${buttonSpecs.buttonId}_corner`);

        if (this.buttonWatermark != null)
            this.buttonWatermark.style.visibility = 'hidden';

        this.buttonGroup = document.getElementById(buttonSpecs.buttonGroup);

        if (this.buttonGroup == null)
            console.log("nullgr", buttonSpecs.buttonGroup)

        this.menuType = this.button.getAttribute("data-menu-type");
        this.highlighter = document.getElementById(buttonSpecs.buttonHighlighterId);
        // TODO: add button-group to buttonSpecs

        this.selection = selection;

        this.currentId = '';

        this.button.addEventListener(
            'pointerenter',
            (event) => {
                let element = event.currentTarget;
                //console.log("APP/MNU: LEVEL_2_POINTER_ENTER()")

                this.slotAction(event, element.id)
            }
        );

        this.button.addEventListener(
            'click',
            (event) => {
                let element = event.currentTarget;
                //console.log("APP/MNU: LEVEL_2_POINTER_ENTER()")

                this.slotAction(event, element.id)
            }
        );

        this.button.addEventListener(
            'pointerleave',
            (event) => {
                this.slotLeave(event);
            }
        );
    }

    timeForUpdate(is_active, img, watermark)
    {
        if (is_active)
        {
            this.button.setAttribute('data-active', "true");
            this.button.classList.remove('item_button_disabled');
        }
        else
        {
            this.button.setAttribute('data-active', "false");
            this.button.classList.add('item_button_disabled');
        }

        console.log('watermark', this.socketCategory, this.socketIndex, watermark);
        this.buttonImage.src = imgPath(img);

        if (this.buttonWatermark != null)
        {
            if (watermark == null)
            {
                this.buttonWatermark.style.visibility = 'hidden';
            }
            else
            {
                this.buttonWatermark.src = imgPath(watermark);
                this.buttonWatermark.style.visibility = 'visible';

            }
        }
    }

    updateSelection(newSelection)
    {
        this.selection = newSelection;
    }

    slotAction(event, html_element_id)
    {
        if (
            (this.manager.getDisplayMode() == "mobile" && event.type == "click") ||
            (this.manager.getDisplayMode() == "pc" && event.type == "pointerenter")
        )
        {
            console.log("APP/MNU: slotAction()")

            if (document.getElementById(html_element_id).getAttribute('data-active') !== 'false')
            {
                this.highlight();
                this.manager.pointer_inside_button = true;

                if (this.selection != null && this.menu != null)
                    this.menu.show(this, this.selection, this.socket.get_current(), this.manager.character);
            }

            if (this.manager.getDisplayMode() == "pc")//(this.screen_width >= 1000 && !this.has_touch_screen) // PC - always show tooltip
            {
                this.manager.tooltip_show(html_element_id, this.socket.get_current(), 1);
            }

            // Mobile - show tooltip only if it is not inactive fragment button
            // document.getElementById(html_element_id).getAttribute('data-active') !== 'false' - checks if button is active
            if (this.manager.getDisplayMode() == "mobile" && document.getElementById(html_element_id).getAttribute('data-active') !== 'false')
            {
                this.manager.tooltip_show(html_element_id, this.socket.get_current(), 1);
            }
        }
    }

    slotLeave(event)
    {
        console.log("APP/MNU: slotLeave()")
        if (this.manager.getDisplayMode() == 'mobile')//(this.has_touch_screen || (!this.has_touch_screen && this.screen_width < 1000))
        {
            event.stopPropagation();
            return;
        }

        this.manager.pointer_inside_button = false;
        this.tooltip.hide();

        let rect = this.button.getBoundingClientRect();

        if (event.clientY < rect.bottom) // leave through bottom, so goes into menu
        {
            this.menu.hide();
        }
        else// just leaves button
        {
            console.log('APP/MNU: entered into selection menu');
        }
    }

    sendChosenEffect(effect_id, effect_type)
    {
        this.set_effect(effect_id, effect_type);
    }

    set_effect(effect_id, effect_type)
    {
        this.masterItem.plugInSocket(effect_id, this.socketCategory, this.socketIndex);
    }

    highlight()
    {
        // before selecting remove and dehighlight old
        this.manager.dehighlightCurrentSlot();

        this.manager.currentSlot = this;

        console.log("APP/MNU: LEVEL_1_BUTTON_SELECTED()");

        if (this.highlighter != null)
        {
            this.highlighter.style.visibility = 'visible';
            this.highlighter.style.opacity = 1;
        }
    }

    dehighlight()
    {
        if (this.highlighter != null)
        {
            this.highlighter.style.visibility = 'hidden';
            this.highlighter.style.opacity = 0;
        }
    }
}